import React, { FC } from 'react'
import { useEyesHook } from './Hooks'
import EyesComponent from './Component'
const Eyes: FC = () => {
  return <EyesComponent {...useEyesHook()} />
}
export default Eyes
